<template>
  <el-dialog
    :visible.sync="show"
    custom-class="gh-terms"
    :width="width"
    :before-close="handleClose"
    top="3vh">
      <h2 class="gh-page__heading pb-1">Terms &amp; Conditions</h2>

            <div class="term">
                <p>The 2022 Suicide Prevention Summit (“Event”) is operated and owned by the Mental Health Academy (“MHA”). By choosing to participate in the 2022 Suicide Prevention Summit as a registered user you agree to the following terms and conditions, whether you have read the terms and conditions or not.</p>
            </div>

            <div class="term">
                <h3 class="term__heading">Disclaimer</h3>
                <p>MHA reserves the right to change the materials, programs, services and products at the 2022 Suicide Prevention Summit entirely at its discretion. Opinions of presenters and contributors to the Event are not necessarily those of MHA or its event partners. Use of material from the Event is not intended to substitute professional, legal, financial or medical advice. When advice is required, we encourage you to seek out a qualified professional.</p>
                <p>MHA makes no representation or warranty that information provided via the Event is accurate, nor accepts liability or responsibility for any action arising out of information provided. You agree to use the information from the Event at your own risk and take sole responsibility for the choices you make.</p>
            </div>

            <div class="term">
                <h3 class="term__heading">Copyright</h3>
                <p>All content from the 2022 Suicide Prevention Summit is the property of the presenters and suppliers and is protected by international copyright laws. This includes but is not limited to the presentations. You are not permitted to use or reproduce any content whatsoever without the express written consent of the copyright owner.</p>
           </div>

            <div class="term">
                <h3 class="term__heading">Access to Content</h3>
                <p>Your registration to the 2022 Suicide Prevention Summit provides you with access to 10 hours of continuing professional development (CPD), delivered online via live webinars (September 10 & 11, 2022) and video recordings (available after the live sessions). While you may choose to pay an attendance fee, your choice (free registration or £10) determines the timeframe you can access video recordings, and the resources that are included with your registration, as outlined below:</p>
                <p>The free registration option includes access to:</p>
                <ul>
                    <li>All live webinars* (September 10 & 11, 2022)</li>
                    <li>7-day access to video recordings</li>
                </ul>
                <p>The&nbsp;$10 (Premium) registration fee includes access to:</p>
                <ul>
                    <li>All live webinars* (September 10 & 11, 2022)</li>
                    <li>Extended access to video recordings (November 6, 2022)</li>
                    <li>Session slides (available in PDF format for download)</li>
                    <li>Post-session Notes (available in PDF format for download)</li>
                </ul>
                <p>*Live webinar sessions are delivered via the WebinarJam platform and can hold a maximum of 5,000 concurrent attendees. Available spots are allocated automatically by the webinar system on a first in, first served basis for each webinar session. While it is unlikely, if you miss out on a real-time webinar session due to capacity being reached, you will be able to watch a recorded version of the session (including Q&A discussion) after the live event (see timeframes for access above).</p>
           </div>

            <div class="term">
                <h3 class="term__heading">Social Impact</h3>
                <p>Mental Health Academy will donate all revenue raised from event registrations to the British Psychological Society (BPS). </p>
           </div>

            <div class="term">
                <h3 class="term__heading">Registration Upgrades</h3>
                <p>You may choose to upgrade a free registration to Premium (£10). By upgrading, you will immediately gain access to resources available via the £10 (Premium) registration option (see “Access to Content” section above for more details).</p>
           </div>

            <div class="term">
                <h3 class="term__heading">Registration Confirmation</h3>
                <p>Upon submitting your registration to attend the 2022 Suicide Prevention Summit, you will receive an instant confirmation via the registration page. You will also receive email confirmation. Please make sure you check both your email inbox and other mail folders (including junk and promotions). If you do not receive an email confirmation, contact us to obtain a copy.</p>
                <p>We also recommend adding <a href="mailto:admin@mentalhealthacademy.co.uk">admin@mentalhealthacademy.co.uk</a> to your email contact list to avoid further emails being blocked by your email SPAM filter and other security settings.</p>
           </div>

            <div class="term">
                <h3 class="term__heading">CPD Certificates</h3>
                <p>Participants of the 2022 Suicide Prevention Summit will gain access to CPD Certificates as evidence of their registration and participation. Instructions to complete evaluation surveys and access CPD Certificates of Attendance will be emailed to registered users during and after the live event period (September 10 & 11, 2022). Refer to the Event’s ongoing email communications and updates for more information. If you cannot locate email instructions, please contact us for assistance.</p>
            </div>

            <div class="term">
                <h3 class="term__heading">Refund Policy</h3>
                <p>As all revenue from this event will be donated to charity, the paid registration fee (£10) for the 2022 Suicide Prevention Summit is non-refundable. Requests for refunds under special circumstances will be considered and reviewed on a per case basis.</p>
            </div>

            <div class="term">
                <h3 class="term__heading">International Transaction Fees</h3>
                <p>All payments are processed in GBP (British Pounds). Some card issuers may charge additional “international fees” to process your payment, depending on your card’s specific terms & conditions (and due to MHA’s head office being located in Australia). MHA is unable to provide refunds or invoices for transaction fees, as these fees are charged by your card issuer, not MHA.</p>
            </div>

            <div class="term">
                <h3 class="term__heading">Website Usage</h3>
                <p>Your access to the 2022 Suicide Prevention Summit only gives you the right to access and use the Summit’s resources. You are not permitted to share your access details with others. Your access does not in any way imply ownership of any material. You are not permitted to publicly share any of the Event’s resources.</p>
                <p>If you have any queries, please contact us via <a href="mailto:help@mentalhealthacademy.co.uk">help@mentalhealthacademy.co.uk</a>.</p>
            </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="show = false">Close</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '85%'
    },
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      show: false
    }
  },

  methods: {
     handleClose(done) {
      //  this.show = false

       this.$emit('hide')
      }
  },

  watch: {
    visible (val) {
      if (val) {
        this.show = true
      } else {
        this.show = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>

  .gh-page__heading {
    word-break: keep-all;
    font-size: 2.5rem;
    font-weight: 600;
  }

  .term{
    font-family: proxima-nova,sans-serif;

  }

  .term p {
    text-align: left;
    + p {
      margin-top: .5rem;
    }
  }
  .term__heading {
    font-size: 1.2rem;
    padding: 1rem 0 .5rem;
    text-align: left;
  }

  p {
    word-break: normal;
  }

  ul {
    list-style: disc;
    padding: 1rem 0 1rem 2rem;
    font-size: 15px;

    li + li {
      margin-top: .25rem;
    }
  }
  .gh-dollar-sign {
        font-family: freight-sans-pro,sans-serif !important;
    }

</style>
